import { Button } from "@/design-system";
import { FORM_SECTION_ID } from "../constants";
import { PartnerLockup } from "./partnerLockup";

type PartnerHeaderProps = {
  onCtaClick: () => void;
};

/**
 * Cabeçalho próprio da LP de parceria: só as duas marcas e o CTA que rola até
 * o formulário. Sem menu nem link para a home — esta página é um canal
 * fechado do time comercial da Alpha7, não uma porta de entrada do site.
 */
export const PartnerHeader = ({ onCtaClick }: PartnerHeaderProps) => (
  <header className="bg-ds-paper/90 border-ds-border sticky top-0 z-20 border-b backdrop-blur-sm">
    <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
      <PartnerLockup size="sm" />
      {/* No celular o CTA do hero está logo abaixo; aqui ele só espremia as marcas. */}
      <Button
        asChild
        variant="primary"
        onClick={onCtaClick}
        className="hidden sm:inline-flex"
      >
        <a href={`#${FORM_SECTION_ID}`}>Indicar farmácia</a>
      </Button>
    </div>
  </header>
);
